const typography = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 13,
  body1: {
    fontWeight: 400, // or 'bold'
    fontSize: 13,
  },
  h1: {
    fontWeight: 600,
    fontSize: 24,
    letterSpacing: "-0.24px",
  },
  h2: {
    fontWeight: 600,
    fontSize: 21,
    letterSpacing: "-0.24px",
  },
  h3: {
    fontWeight: 600,
    fontSize: 18,
    letterSpacing: "-0.06px",
  },
  h4: {
    fontWeight: 600,
    fontSize: 16,
    letterSpacing: "-0.06px",
  },
  h5: {
    fontWeight: 600,
    fontSize: 14,
    letterSpacing: "-0.05px",
  },
  h6: {
    fontWeight: 600,
    fontSize: 13,
    letterSpacing: "-0.05px",
  },
  buttons: {
    textTransform: "none",
  },
};

export default typography;
